import DownloadCategory from '../icon/download-full-color.svg'
import PodcastCategory from '../icon/podcast-full-color.svg'
import EbookCategory from '../icon/ebooks-full-color.svg'

export const KIND_DOCUMENT = 'document'
export const KIND_AUDIO = 'audio'
export const KIND_EBOOK = 'ebook'
export const KIND_GAMIFICATION = 'gamification'

export const KIND_ICON_MAP = {
  document: DownloadCategory,
  audio: PodcastCategory,
  ebook: EbookCategory
}

export const KIND_LABEL_MAP = {
  document: 'Documento',
  audio: 'Audio',
  ebook: 'Ebook',
  gamification: 'Gamification'
}

export const KIND_LABEL_PLURAL_MAP = {
  document: 'Documentos',
  audio: 'Podcasts',
  ebook: 'Ebooks',
  gamification: 'Gamification'
}

export const KIND_PATH_MAP = {
  document: 'documentos',
  audio: 'podcasts',
  ebook: 'ebooks',
  gamification: 'gamification'
}
export const KIND_COLOR_MAP = {
  document: 'bg-turquoise-600',
  audio: 'bg-yellow-500',
  ebook: 'bg-red-400'
}
